import {
	Component,
	EventEmitter,
	Input,
	Output,
	TemplateRef
}                        from '@angular/core';
import { BaseComponent } from '@app/core/bases/base-component/base.component';


@Component( {
	selector: 'app-page-header',
	templateUrl: './page-header.component.html',
	styleUrls: [ './page-header.component.scss' ]
} )
export class PageHeaderComponent extends BaseComponent {

	isHovered: boolean;

	@Input() aboveHeaderContent: TemplateRef<any>;
	@Input() pageActionTpl: TemplateRef<any>;
	@Input() pageHeaderWrapperStyleClassOverwrite = 'pb-2 ps-3 px-md-0';
	@Input() secondaryTitle: string;
	@Input() showBackNav: boolean;
	@Input() showElsterIndicator: boolean = false;
	@Input() showHeaderSeparator = true;
	@Input() subcontent: TemplateRef<any>;
	@Input() title: string;
	@Input() titleAsInnerHtml: string;
	@Input() titleIsSelectable: boolean;

	@Output() navigateBackEmitter: EventEmitter<null> = new EventEmitter();


	navigateBack() {
		this.isHovered = false;
		this.navigateBackEmitter.emit();
	}
}
